// BE#657 — the compose "Schedule Send" gate, extracted as a pure predicate so the
// chokepoint can be unit-tested. The load-bearing clause is `dueDateSetByUser`: a
// draft that carries a valid dueDate the user never explicitly picked (a seeded ~now
// value) is NOT sendable, which is what stopped the "fired days early" sends.

export interface ScheduleSendGateInput {
  isFileUploading: boolean;
  timeInputInvalid: boolean;
  dueDateInThePast: boolean;
  /** dueDate is present AND a valid date. */
  hasValidDueDate: boolean;
  /** the user explicitly picked/confirmed the date (not a seed). */
  dueDateSetByUser: boolean;
  recipientCount: number;
  /** message text / asset / image present, or a valid poll. */
  hasContentOrPoll: boolean;
}

export function canScheduleSend(i: ScheduleSendGateInput): boolean {
  return (
    !i.isFileUploading &&
    !i.timeInputInvalid &&
    !i.dueDateInThePast &&
    i.hasValidDueDate &&
    i.dueDateSetByUser &&
    i.recipientCount > 0 &&
    i.hasContentOrPoll
  );
}
